// French: reference language. Every key must exist here; en.ts and ar.ts
// fall back to it for any missing key.
export default {
  common: {
    loading: "Chargement...",
  },
  header: {
    openMenu: "Ouvrir le menu",
    home: "Accueil",
    language: "Langue",
    searchPlaceholder: "Rechercher une page...",
    searchLabel: "Rechercher une page",
    noResult: "Aucun résultat trouvé",
    notifications: "Notifications",
    notificationsUnread: "Notifications, {count} non lue(s)",
    markAllRead: "Tout marquer comme lu",
    noNotifications: "Aucune notification",
    onlineAccount: "Compte en ligne",
    myAccount: "Mon compte",
    myProfile: "Mon profil",
    profile: "Profil",
    settings: "Paramètres",
    logout: "Déconnexion",
    roleAdmin: "Admin",
    roleClient: "Client",
    roleDriver: "Livreur",
    roleZoneManager: "Responsable de zone",
    justNow: "À l'instant",
    minutesAgo: "Il y a {n} min",
    hoursAgo: "Il y a {n} h",
  },
  theme: {
    enableLight: "Activer le mode clair",
    enableDark: "Activer le mode sombre",
    light: "Mode clair",
    dark: "Mode sombre",
  },
  sidebar: {
    mainNav: "Navigation principale",
    mainMenu: "Menu principal",
    closeMenu: "Fermer le menu",
    loadingMenu: "Chargement du menu",
  },
  menu: {
    dashboard: "Dashboard",
    parcels: "Colis",
    addParcel: "Nouveau colis",
    parcelsList: "Liste des colis",
    pickupParcels: "Colis pour ramassage",
    followups: "Suivi et relance",
    exchanges: "Échange",
    importParcels: "Importation colis",
    inventory: "Inventaire",
    productsList: "Liste des produits",
    stockParcels: "Colis de stock",
    deliveryNotes: "Bons de livraison",
    addDeliveryNote: "Nouveau bon de livraison",
    myInvoices: "Mes factures",
    refunds: "Remboursements",
    newRequest: "Nouvelle demande",
    myRequests: "Mes demandes",
    balanceHistory: "Historique du solde",
    returnNotes: "Bons de retour",
    claims: "Réclamations",
    pickup: "Ramassage",
    users: "Utilisateurs",
    subAccounts: "Sous-comptes",
    blackList: "Black liste",
    apiDocs: "Documentation API",
    myDocuments: "Mes documents",
    ribChange: "Changement de RIB",
    phoneChange: "Changement de téléphone",
    webhooks: "Webhooks",
    profile: "Profil",
  },
  account: {
    activeAccount: "Compte actif : {name}",
    switchHint: " — changer de compte",
    subAccountOf: "Sous-compte · {name}",
    mainAccount: "Compte principal",
    subAccount: "Sous-compte",
    inactive: "Inactif",
    switchAccount: "Changer de compte",
    allAccounts: "Tous les comptes",
    manageSubAccounts: "Gérer les sous-comptes",
    enterFailed: "Impossible d'accéder à ce compte",
  },
};
